module.exports = __webpack_public_path__ + "static/img/icon-withdraw-active.f2cbd01.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icon-withdraw-active.png
// module id = Sf4S
// module chunks = 3